import { fromPromise } from 'xstate5';

import { OrderPaymentStatus } from '@sg/graphql-schema';

// ─────────────────────────────────────────────────────────────────────────────

const fetchPaymentState = fromPromise<FetchPaymentStateResponse, FetchPaymentStateParams>(
  async () => {
    return {
      orderId: undefined,
      paymentIntentId: undefined,
      paymentStateExpiration: undefined,
      paymentStateStatus: undefined,
      paymentStateError: undefined,
    };
  },
);

const cancelPayment = fromPromise<CancelPaymentResponse, CancelPaymentParams>(async () => {
  return {
    success: false,
  };
});

export const PaymentStatePollingActors = {
  fetchPaymentState,
  cancelPayment,
};

// ─── Types ───────────────────────────────────────────────────────────────────

export type FetchPaymentStateParams = {
  orderId?: string;
};

export type FetchPaymentStateResponse = {
  orderId: string | undefined;
  paymentIntentId: string | undefined;
  paymentStateExpiration: number | undefined;
  paymentStateStatus: OrderPaymentStatus | undefined;
  paymentStateError: string | undefined | null;
};

export type CancelPaymentResponse = {
  success: boolean;
};

export type CancelPaymentParams = {
  paymentIntentId: string | undefined;
};
